export const tooltipDataSource = [
	'<Account>',
	'<Agent>',
	'<Asset>',
	'<CategoryNode>',
	'<CategoryPath>',
	'<Instance>',
	'<Metric name>',
	'<MetricId>',
	'<MetricType>',
	'<RegistryIdentifier>',
	'<RegistryOwnerId>',
	'<RegistryType>',
	'<Source>',
	'<Time>',
	'<Timezone>',
	'<Unit>',
	'<Value and unit>'
] as const;

export const tooltipOptions = tooltipDataSource.map(x => ({
	label: x,
	value: x
}))

export const tooltipDefaultValue = ['<Time>', '<Metric name>', '<Value and unit>'] as const;

